<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="tests" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="testId"
  (onEditInit)="onCellEditInit($event)" (onEditComplete)="onCellEditComplete($event)"
  (onEditCancel)="onCellEditCancel()" selectionMode="single" [(selection)]="test" (onRowSelect)="onRowSelect($event)"
  [loading]="loading" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end">
      <span>
        <!--clear filters-->
        <button pButton pRipple class="p-button-text"
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
        (click)="reloadPage()">Clear Filters</button>

        <!--add new-->
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
        (click)="onOpenFormAdd()">New Test +</button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    <tr>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'testId', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'description', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'status', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-test>
    <tr [pEditableRow]="test">
      <td>{{test.testId}} </td>
      <td [pEditableColumn]="test" [pEditableColumnField]="'name'">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText type="text" [(ngModel)]="test.name">
          </ng-template>
          <ng-template pTemplate="output">
            {{test.name}}
          </ng-template>
        </p-cellEditor>
      </td>
      <td [pEditableColumn]="test" [pEditableColumnField]="'description'">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText type="text" [(ngModel)]="test.description" required>
          </ng-template>
          <ng-template pTemplate="output">
            {{test.description}}
          </ng-template>
        </p-cellEditor>
      </td>

      <td [pEditableColumn]="test" [pEditableColumnField]="'status'">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText type="text" [(ngModel)]="test.status" required>
          </ng-template>
          <ng-template pTemplate="output">
            {{getStatusName(test)}}
          </ng-template>
        </p-cellEditor>
      </td>
      <td><span style="float:none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true" style="color:blue; font-size:110%; padding-right:20px;"
          (click)="onOpenFormEdit(test)"></i>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>